export default __webpack_public_path__ + "static/media/dropdown.ae6f17fe.svg";